import { connect } from 'react-redux';
import { ManageEquipmentList as ManageEquipmentListComponent } from './manage-equipment-list.component';
import { AppState } from '../../app.state';

export const ManageEquipmentList = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageEquipmentListComponent as any
) as unknown as typeof ManageEquipmentListComponent;
